import React from 'react'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'

import PortalGalleryImageFormContainer from './PortalGalleryImageFormContainer'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import { updateGalleryImage } from '../../../actions/portal'

class PortalGalleryImageFormModalWithRedux extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose(params) {
    if (params) {
      console.log("params", params)
      this.props.actions.updateGalleryImage(params)
    }
    this.props.modalActions.hideModal()
  }

  render() {
    return (
      <PortalGalleryImageFormContainer
        onRequestClose={this.handleClose}
        params={this.props.modal.openParams}
      />
    )
  }
}

PortalGalleryImageFormModalWithRedux.propTypes = {
  ...modalPropTypes,
}

export default compose(
  withReduxModal,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(
        { updateGalleryImage: updateGalleryImage },
        dispatch,
      ),
    }),
  ),
)(PortalGalleryImageFormModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/portal-gallery-image/PortalGalleryImageFormModalWithRedux.js